import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Panel_creador.css';

const PanelCreador = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
const [cuentaData, setCuentaData] = useState({
    email: '',
    saldo: '0',
    diasRestantes: '0',
    publicacionesActivas: '0',
    publicacionesPausa: '0',
    accesoSaldo: false
  });
  const [adminImpersonando, setAdminImpersonando] = useState(false);

  // Cargar datos de la cuenta al montar el componente
  useEffect(() => {
    cargarDatosCuenta();
  }, []);

  const cargarDatosCuenta = async () => {
    try {
      setLoading(true);
      // TODO: Reemplazar localhost con la URL del backend desde .env
      const response = await fetch(`${process.env.REACT_APP_AUTH_CREADOR_URL}/get_cuenta.php`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Error al cargar datos de la cuenta');
      }

      const data = await response.json();
      if (data.success) {
setCuentaData({
          email: data.email || '',
          saldo: data.saldo || '0',
          diasRestantes: data.dias_restantes || '0',
          publicacionesActivas: data.publicaciones_activas || '0',
          publicacionesPausa: data.publicaciones_pausa || '0',
          accesoSaldo: data.acceso_saldo || false
        });
        setAdminImpersonando(!!data.admin_impersonando);
      }
    } catch (error) {
      console.error('Error al cargar datos:', error);
    } finally {
      setLoading(false);
    }
  };

  // Handlers para los botones
  const handleCambiarContrasena = () => {
    navigate('/cambio_contrasena_creador');
  };

const handleCerrarSesion = async () => {
    try {
      await fetch(`${process.env.REACT_APP_AUTH_CREADOR_URL}/logout.php`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (e) {
      console.error('Error al cerrar sesión:', e);
    }
    // Usar window.location para bypasear el blocker — es logout explícito
    window.location.href = '/';
  };

  // TODO: Navegar a página de publicar anuncio
  const handlePublicaAnuncio = () => {
    navigate('/publica_anuncio');
  };

  const handleEstadoPublicaciones = () => {
    navigate('/estado_publicaciones');
  };

  const handleProcesoVerificacion = () => {
    navigate('/proceso_verificacion');
  };

  const handleEstadoVerificaciones = () => {
    // TODO: Navegar a página de estado de verificaciones
    navigate('/estado_verificacion');
  };

const handleSaldoOrdenCompra = () => {
    if (!cuentaData.accesoSaldo) {
      alert('Debes esperar a que el estado de tu publicacion y verificacion esten aprobadas');
      return;
    }
    navigate('/saldo_ordencompra');
  };

  const handleFacturacion = () => {
    // TODO: Navegar a página de facturación
    console.log('Facturación');
  };

  const handleActivos = () => {
    navigate('/gestion_avisos');
  };

  const handlePausa = () => {
    // TODO: Navegar a página de avisos en pausa
    console.log('Avisos en pausa');
  };

  const handleNoActivos = () => {
    // TODO: Navegar a página de avisos no activos
    console.log('Avisos no activos');
  };

  const handleMensajeria = () => {
    // TODO: Navegar a página de mensajería
    console.log('Mensajería');
  };

  const handleContactarWhatsapp = () => {
    window.open('https://wa.me/56929674732', '_blank');
  };

  const handleTelegram = () => {
    // TODO: Reemplazar con el enlace real de Telegram
    window.open('https://t.me/ulalaaa', '_blank');
  };

  return (
    <div className="panel-creador-container">
      {/* Header con logo */}
      <div className="panel-header">
        <div className="logo-container">
          <span className="logo-text">Ulalaaa</span>
          <span className="logo-subtitle">Logo</span>
        </div>
      </div>

      {/* Sección Cuenta */}
      <div className="seccion-cuenta">
        <div className="cuenta-header">
          <h2 className="cuenta-titulo cuenta-titulo-dorado">Cuenta {cuentaData.email && `- ${cuentaData.email}`}</h2>
          <div className="cuenta-botones"></div>
            <button className="btn-cambiar-contrasena" onClick={handleCambiarContrasena}>
              Cambiar contraseña
            </button>
            {!adminImpersonando && (
              <button className="btn-cerrar-sesion" onClick={handleCerrarSesion}>
                Cerrar sesión - Volver a pagina principal
              </button>
            )}
          </div>

      </div>

      {/* Sección Publicar - FASE 1 */}
      <div className="seccion-publicar">
        <div className="fase-header">
          <h2 className="seccion-titulo">Publicar</h2>
          <div className="fase-badge">FASE 1</div>
        </div>
        
        <div className="publicar-botones">
          <button className="btn-publica-anuncio" onClick={handlePublicaAnuncio}>
            Publica tu anuncio
          </button>
          <button className="btn-estado-publicaciones" onClick={handleEstadoPublicaciones}>
            Estado de tus publicaciones
          </button>
          <button className="btn-proceso-verificacion" onClick={handleProcesoVerificacion}>
            Proceso de verificación
          </button>
          <button className="btn-estado-verificaciones" onClick={handleEstadoVerificaciones}>
            Estado de tus verificaciones
          </button>
        </div>
      </div>

      {/* Sección Pago - FASE 2 */}
      <div className="seccion-pago">
        <div className="fase-header">
          <h2 className="seccion-titulo">PAGO</h2>
          <div className="fase-badge">FASE 2</div>
        </div>
        
        <div className="pago-botones">
          <button className="btn-anadir-saldo" onClick={handleSaldoOrdenCompra}>
            Activacion Publicacion - Saldo - Renovacion publicacion
          </button>
          <button className="btn-facturacion" onClick={handleFacturacion}>
            Facturación
          </button>
        </div>
      </div>

      
      {/* Sección Tus Avisos */}
      <div className="seccion-avisos">
        <h2 className="seccion-titulo">TUS AVISOS</h2>
        
        <div className="avisos-botones">
          <button className="btn-activos" onClick={handleActivos}>
            Gestión - Avisos
          </button>
        </div>
      </div>

      {/* Sección Ayuda Soporte */}
      <div className="seccion-soporte">
        <h2 className="seccion-titulo">Ayuda Soporte</h2>
        
        <div className="soporte-content">
          <div className="contacto-whatsapp">
            <p className="contacto-texto">Al momento de contactar indica tu correo</p>
            <button className="btn-contactar-whatsapp" onClick={handleContactarWhatsapp}>
              Contactanos via Whatsapp
            </button>
            <p className="horario-texto">Horario todos los días: 10 a 1 am</p>
          </div>

          <div className="contacto-whatsapp">
            <p className="contacto-texto">También puedes contactarnos por Telegram</p>
            <button className="btn-telegram" onClick={handleTelegram}>
              Contactanos via Telegram
            </button>
          </div>
        </div>
</div>

      {/* Copia de barra de navegacion - antes del footer */}
      <div style={{
        background: '#3a0d09', padding: '8px 16px', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        flexWrap: 'wrap', gap: '10px'
      }}>
        <button onClick={() => navigate('/panel_creador')} style={{ background: '#f4a261', color: '#3b1a00', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <i className="fas fa-home"></i> Panel inicial
        </button>
        <button onClick={() => window.history.length <= 2 ? navigate('/panel_creador') : navigate(-1)} style={{ background: '#1e3a8a', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <i className="fas fa-arrow-left"></i> Pagina anterior
        </button>
        <button onClick={handleCerrarSesion} style={{ background: '#dc143c', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <i className="fas fa-sign-out-alt"></i> Cerrar sesion
        </button>
      </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
};

export default PanelCreador;
